import { MetaInfo } from "@/components/meta-info"
import { ChangelogSettings } from "@/screens/app/changelog/changelog-settings"
import { SettingsHeader } from "../settings-header"

export function ChangelogSettingsPage() {
	return (
		<>
			<MetaInfo title="Changelog Settings" />

			<SettingsHeader
				title="Changelog"
				subtitle="Publish a beautiful changelog and notify users in-app."
				docsArticle="90840b98-ee11-4eb0-b7a0-c24c8196c646"
			/>
			<ChangelogSettings />
		</>
	)
}
